import stylesModule from './ModelEditLineage.module.scss';

export const styles = stylesModule;
